import { saveAs } from 'file-saver';
import { pdf } from '@react-pdf/renderer';

// const downloadPDF = async (fileName) => {
//   const pdfDocument = (
//     <ReportExportPDF
//       reportName="Summary Report"
//       dataBlocks={[
//         new DataBlock('Test', [new DataBlockChunk('TEST1', 'TEST2')])
//       ]}
//       tableData={
//         new TableData(
//           ['TESTh', 'TESTH2'],
//           [
//             ['row1', 'row1-2'],
//             ['row2', 'row2-2']
//           ]
//         )
//       }
//     />
//   );

//   const asPdf = pdf([]);
//   asPdf.updateContainer(pdfDocument);
//   const blob = await asPdf.toBlob();
//   saveAs(blob, `${fileName}.pdf`);
// };

const downloadPDF = async (fileName, pdfDocument) => {
  const asPdf = pdf([]);
  asPdf.updateContainer(pdfDocument);
  const blob = await asPdf.toBlob();
  saveAs(blob, `${fileName}.pdf`);
};

export default downloadPDF;
